module.exports = __webpack_public_path__ + "static/media/krogkungshuset.8ce68c08.png";